import styled from 'styled-components';
import { IconProps } from './types';
import sizing from '../../designSystem/sizing';

export const Icon = styled.img<IconProps>`
    max-height: ${({ height }) => (height ? height : sizing.ICON.HEIGHT.LARGE)};
`;
